import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
	DsConfirmData,
	DsConfirmDialogComponent,
} from "../components/ds-confirm-dialog/ds-confirm-dialog.component";

/**
 * Servicio único para diálogos del design-system. Centraliza el estilo cohesionado
 * (cabecera con icono por tipo, overlay tipo Ctrl+K, botones del sistema).
 *
 * Uso: `dialogService.confirm({ type:'danger', title, message }).subscribe(ok => ...)`.
 */
@Injectable({ providedIn: "root" })
export class DialogService {
	constructor(
		private readonly dialog: MatDialog,
		private readonly translate: TranslateService,
	) {}

	/** Diálogo de confirmación/aviso. Devuelve true si se confirma. */
	confirm(opts: DsConfirmData): Observable<boolean> {
		const data: DsConfirmData = {
			...opts,
			type: opts.type ?? "confirm",
			confirmText:
				opts.confirmText ?? this.translate.instant("common.confirm"),
			cancelText:
				opts.cancelText ?? this.translate.instant("common.cancel"),
			confirmTone:
				opts.confirmTone ?? (opts.type === "danger" ? "danger" : "primary"),
		};

		return this.dialog
			.open(DsConfirmDialogComponent, {
				data,
				width: "440px",
				maxWidth: "92vw",
				autoFocus: false,
				restoreFocus: true,
				panelClass: "ds-dialog-panel",
				backdropClass: "ds-dialog-backdrop",
			})
			.afterClosed()
			.pipe(map((result) => result === true));
	}
}
